export const Method = {
  GET: `GET`,
  POST: `POST`,
};
